import Requirement from './Requirement';
export default class Need extends Requirement {
    constructor(private permission: string) {
        super();
    }

    isSatisfied = (credentials: string[]): boolean => credentials.indexOf(this.permission) !== -1;
}
